<template>
    <div class="enter mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="timePicker">{{groupList.item1.lable}}</label>
                        <el-date-picker id="timePicker" class="inputInner" v-model="groupList.item1.value" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" class="inputInner" v-model="groupList.item2.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item2.selectOrinput" class="input_label" for="input">{{groupList.item2.lable}}</label>
                        <el-input v-if="!groupList.item2.selectOrinput" id="input" class="inputInner" v-model="groupList.item2.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div  class="input_group" v-if="groupList.item3.isShow">
                        <label v-if="groupList.item3.selectOrinput" class="input_label" for="select">{{groupList.item3.lable}}</label>
                        <el-select v-if="groupList.item3.selectOrinput" id="select" class="inputInner" v-model="groupList.item3.value" placeholder="单位">
                            <el-option
                            v-for="item in groupList.item3.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                       
                        <label v-if="!groupList.item3.selectOrinput" class="input_label" for="input">{{groupList.item3.lable}}</label>
                        <div>
                            <el-input style="width:65%" v-if="!groupList.item3.selectOrinput" id="input" class="inputInner" v-model="groupList.item3.value" placeholder="请输入内容"></el-input>
                            <el-select style="width:15%" placeholde='单位' v-model="groupList.item5.value">
                                <el-option
                                    v-for="item in groupList.item5.selectOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        
                    </div>
                    <div class="input_group" v-if="groupList.item4.isShow">
                        <label v-if="groupList.item4.selectOrinput" class="input_label" for="select">{{groupList.item4.lable}}</label>
                        <el-select v-if="groupList.item4.selectOrinput" id="select" class="inputInner" v-model="groupList.item4.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item4.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item4.selectOrinput" class="input_label" for="input">{{groupList.item4.lable}}</label>
                        <el-input v-if="!groupList.item4.selectOrinput" id="input" class="inputInner" v-model="groupList.item4.value" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="box_bottom" v-if="boxBottom.isBoxBottom">
                        <label class="input_label" for="beizhu">{{boxBottom.label}}</label>
                        <el-input id="beizhu" v-model="boxBottom.input" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="add_box">
                <button class="formButton add_btn" @click="submit" >添加</button>
            </div>
        </div>
        <div class="table_area">
            <div class="left">
                <el-table
                :stripe='true'
                        ref='table'
                        :key="itemKey"
                        class="cusorTable"
                        :data="tableData"
                        @cell-click='cellClick'
                        height="100%"
                        style="width: 100%;">
                        <el-table-column
                            prop="materialName"
                            label="材料名称"
                            width="130"
                            align='center'>
                        </el-table-column>
                        <el-table-column
                            prop="totalNum"
                            label="进场总量"
                            width="80"
                            align='center'>
                        </el-table-column>
                        <el-table-column
                            prop="unit"
                            label="单位"
                            align='center'>
                        </el-table-column>
                        <!-- <el-table-column
                            prop="option"
                            label="操作"
                            align='center'>
                            <button class="tablebtn_inner btnView">查看</button>
                        </el-table-column> -->
                </el-table>
            </div>
            <div class="right">
                <el-table
                :stripe='true'
                        :data="tableData_submenu"
                        height="100%"
                        style="width: 100%;">
                        <el-table-column
                            prop="entryTime"
                            label="进场日期"
                            align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="boatId"
                            label="用料船舶"
                            align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="number"
                            align="center"
                            label="进场量">
                        </el-table-column>
                        <el-table-column
                            prop="unit"
                            align="center"
                            label="单位">
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            align="center"
                            label="操作">
                            <template slot-scope="scope">
                                <button class="tablebtn_inner btnDelet" @click="openDelete(scope.$index,scope.row)">删除</button>
                            </template>
                        </el-table-column>
                </el-table>
            </div>

        </div>
        
    </div>
</template>

<script>
// import css from '@/css/form.css'
// import css from '@/css/enter.css'
import API from '@/api/material'
import moment from 'moment'

export default {
    name:'enter',
    data(){
        return{
            itemKey:false,
            value:'',
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'进场时间',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
       
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'材料类型',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
     
                },
                item3:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    lable:'进场量',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
        
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'用料船舶',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item5:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'单位',
                    selectOptions:[
                        {
                            value:'米',
                            label:'米'
                        },
                    ],
                    placeHolder:'单位',
                    value:null,
                },
                length:5
            },
            boxBottom:{
                isBoxBottom:true,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            tableData_submenu:[],
            AllClass:this.$store.state.AllClass,
        }
    },
    methods:{
        delete(index,row){
            let list = this.tableData_submenu;
            let param = {
                action:'delete',
                id:list[index].id,
            }
            return new Promise((resolve,reject)=>{
                API.deleteEntryList(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            }) 
        },
        openDelete(index,row) {
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete(index,row).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },
        addMethod(){
            let list = this.groupList
                let tmpValue ={
                    action:'add',
                    boat_id:list.item4.value||'',
                    entryTime:list.item1.value||'',
                    materialtype_id:list.item2.value||'',
                    number: list.item3.value||'',
                    unit:list.item5.value,
                    mark:this.boxBottom.input||""
                };
                API.AddEntryMaterial(tmpValue).then(res=>{
                    console.log('res',res);
                    
                }).then(()=>{
                    this.synchrodata();
                })
        },
        open() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addMethod()
                this.$message({
                    message: '添加成功',
                    type: 'success'
                    });
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        synchrodata(){
            new Promise((resolve,reject)=>{
                API.getMaterial_nums(this.$store.state.API_params2)
                .then(res=>{
                    this.AllClass.AllMaterialTypeNum = res.message.obj;
                })
                .then(()=>{
                    API.getMaterial_getall(this.$store.state.API_params).then(res=>{
                        this.AllClass.AllMaterialSubMenu = res.message.obj;
                        resolve(res.message.obj);
                    }).catch(err=>{
                        resolve(0);
                        console.log(err);
                    });
                })
                .catch(err=>{
                    console.log(err);
                })
                
            }).then((a)=>{
                if(a !=null){
                    this.getGroupList();
                    this.getTableList();
                }else{
                    this.$message({
                        type:'error',
                        message:'返回参数为空'
                    })
                    this.getGroupList();
                    this.getTableList();
                }
                
            })

        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.open()
              
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 1;i <= this.groupList.length;i++){
                if(this.groupList[`item${i}`].value == null ||this.groupList[`item${i}`].value == ''){
                    console.log('this.groupList',this.groupList[`item${i}`]);
                    result = false;
                }
            }
            return result
        },
        formattingDate(date) {
            return moment(date).format("YYYY-MM-DD HH:mm");
            },
        formatMaterialList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].materialName,
                })
            }
            return tmpList
        },
        formatShipList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].boat_id,
                    label:list[i].boat_id,
                })
            }
            return tmpList

        },
        formatTableList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    materialName:list[i].materialName,
                    totalNum:list[i].totalNum,
                    id:list[i].id,
                    detail:list[i].detail,
                    unit:'米',
                    option:'单击查看'
                })
            }
            return tmpList
        },
        formatTableList_submenu(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    entryTime:this.formattingDate(list[i].entryTime||''),
                    boatId:list[i].boatId||'',
                    number:list[i].number||'',
                    id:list[i].id||'',
                    unit:'米',
                    option:'删除'
                })
            }
            return tmpList
        },
        getGroupList(){
            this.groupList.item2.selectOptions = this.formatMaterialList(this.AllClass.AllMaterialType||{});
            this.groupList.item4.selectOptions = this.formatShipList(this.AllClass.AllShip||{});
        },
        getTableList(){
            this.tableData = this.formatTableList(this.AllClass.AllMaterialTypeNum||{}) ;
            this.tableData_submenu = this.formatTableList_submenu(this.AllClass.AllMaterialSubMenu||{}) ;
        },
        
        cellClick(item){
            API.getMaterial({action:'getall_materialType_id',materialtype_id:item.id||''}).then((res)=>{
                this.tableData_submenu = this.formatTableList_submenu(res.message.obj)
            }).catch((err)=>{console.log(err);})
        },

        
    },
    created(){
            this.synchrodata()
            
        
        
  }

}
</script>

<style scoped>
.table_area{
    margin-top: 1.4%;
    height: 45%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    overflow: visible !important;
    border-radius: var(--border--radius);
    background-color: var(--subject--body);
    box-shadow: none !important;
}

</style>>


